import axios from '@/axios.js'

import { QuerySerialize } from '@/utils'
import { apolloClient } from '@/vue-apollo'
import { GET_PLACE, GET_PLACES } from '@/store/places/modulePlacesGraphql'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createPlace(context, placeData) {
    return new Promise((resolve, reject) => {
      axios
        .post('places', placeData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countPlaces(context) {
    const query = QuerySerialize(context.state.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`places/count/?${query}`)
        .then(response => {
          context.commit('SET_PLACES_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchPlaces(context) {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: GET_PLACES,
          variables: {
            filter: {
              query: context.state.query,
              skip: context.state.skip,
              limit: context.state.limit,
              sort: context.state.sort
            }
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          context.commit('SET_PLACES', response.data.places)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchPlace(context, placeId) {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: GET_PLACE,
          variables: {
            id: placeId
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          context.commit('SET_PLACE', response.data.place)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchPlaceRest(context, placeId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`places/${placeId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removePlace(context, placeId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`places/${placeId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editPlace(context, place) {
    return new Promise((resolve, reject) => {
      axios
        .put(`places/${place.id}`, place.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editPlaceState(context, place) {
    return new Promise((resolve, reject) => {
      axios
        .put(`places/${place.id}/state`, { state: place.state })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
